<app-dropdown *ngIf="externalToolbarTarget || (blocksConfig.editable && !tableMode)"
              #toolbarDropdown
              [externalTarget]="externalToolbarTarget || editorDiv"
              placement="top-start"
              [renderPanelInBody]="true"
              [hideOnInnerClick]="false"
              [hideOnOuterClick]="false"
              elevation="4"
              [flip]="false"
              hideMethod="css"
              [preventOverflow]="true"
              [offsetTop]="true"
              [preventOverflowBoundaryElement]="toolbarScrollingContainer || 'clippingParents'">

  <div *dropdownPanel>
    <app-rich-text-toolbar
      [state]="state"
      [selectedText]="selectedText"
      [variables]="variables"
      [variableSearchQuery]="variableSearchQuery"
      [richTextBlockIds]="[block.id]"
      (close)="toolbarDropdown.hide()">
    </app-rich-text-toolbar>
  </div>
</app-dropdown>

<div [id]="'rte' + block.id" #editorDiv (keydown)=" handleKeyDown($event) " (keyup)=" handleKeyUp($event) "></div>
